export const MEETING_TYPES = [
  { key: "family_consultation", label: "Family Consultation Room" },
  { key: "professional_review", label: "Professional Review Room" },
  { key: "partner_planning", label: "Partner / Vendor Planning Room" },
  { key: "internal_team", label: "Internal Team Room" },
  { key: "temporary_guest_continuation", label: "Temporary Guest Continuation Room" },
];

export const MEETING_STATUSES = [
  { key: "draft", label: "Draft", hex: "#6B7280" },
  { key: "scheduled", label: "Scheduled", hex: "#2C6480" },
  { key: "waiting", label: "Waiting", hex: "#B7791F" },
  { key: "active", label: "Active", hex: "#2F7D5A" },
  { key: "completed", label: "Completed", hex: "#1C4358" },
  { key: "cancelled", label: "Cancelled", hex: "#9C1E22" },
  { key: "no_show", label: "No-show", hex: "#9C1E22" },
  { key: "follow_up_needed", label: "Follow-up Needed", hex: "#B7791F" },
];

export const typeLabel = (k) => MEETING_TYPES.find((t) => t.key === k)?.label || k;
export const statusMeta = (k) => MEETING_STATUSES.find((s) => s.key === k) || { key: k, label: k, hex: "#6B7280" };
export const fmtDate = (iso) => {
  if (!iso) return "Not scheduled";
  try { return new Date(iso).toLocaleString([], { dateStyle: "medium", timeStyle: "short" }); } catch { return iso; }
};

export const ROOM_DOC_TYPES = [
  { key: "poa_contact", label: "Power of attorney / contact notes" },
  { key: "home_photos", label: "Home photos" },
  { key: "room_photos", label: "Room / bathroom / stair photos" },
  { key: "move_inventory", label: "Move inventory" },
  { key: "property_notes", label: "Property notes" },
  { key: "care_notes", label: "Care notes" },
  { key: "facility_paperwork", label: "Facility paperwork" },
  { key: "contract_agreement", label: "Contract / agreement" },
  { key: "quote_estimate", label: "Quote / estimate" },
  { key: "id_contact", label: "ID / contact information" },
  { key: "other", label: "Other" },
];
export const ROOM_DOC_STATUSES = [
  { key: "requested", label: "Requested", hex: "#B7791F" },
  { key: "uploaded", label: "Uploaded", hex: "#2C6480" },
  { key: "under_review", label: "Under review", hex: "#7C3AED" },
  { key: "approved", label: "Approved", hex: "#2F7D5A" },
  { key: "needs_changes", label: "Needs changes", hex: "#9C1E22" },
  { key: "archived", label: "Archived", hex: "#6B7280" },
];
export const DOC_AUDIENCES = [
  { key: "client", label: "Client" },
  { key: "temporary_guest", label: "Temporary guest" },
  { key: "professional_guest", label: "Professional guest" },
  { key: "partner_vendor", label: "Partner / vendor" },
];
export const AGREEMENT_STATUSES = [
  { key: "agreement_needed", label: "Agreement needed" },
  { key: "document_requested", label: "Document requested" },
  { key: "document_uploaded", label: "Document uploaded" },
  { key: "review_pending", label: "Review pending" },
  { key: "signing_pending", label: "Signing pending" },
  { key: "signed_externally", label: "Signed externally" },
  { key: "completed", label: "Completed" },
];
export const docTypeLabel = (k) => ROOM_DOC_TYPES.find((t) => t.key === k)?.label || k;
export const docStatusMeta = (k) => ROOM_DOC_STATUSES.find((s) => s.key === k) || { key: k, label: k, hex: "#6B7280" };
